import '.a{display:grid;}.ssr-plugin'
import '.gw{gap:1.25rem;}.ssr-plugin'
import { Checkbox } from './Checkbox'
import { Style, styled } from 'inlines'

export interface CheckboxGroupOption<T> {
  label: string
  tooltipText?: string
  value: T
  key?: string | number
}

export interface CheckboxGroupProps<T> {
  options: CheckboxGroupOption<T>[]
  selected: T[]
  onToggle: (value: T) => void
  columns?: number
  style?: Style
}

export const CheckboxGroup = <T,>({
  options,
  selected,
  onToggle,
  columns = 2,
  style,
}: CheckboxGroupProps<T>) => {
  return (
    <styled.div className="a gw"
      style={{
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        ...style,
      }}
    >
      {options.map((option) => (
        <Checkbox
          key={option.key ?? (option.value as unknown as string)}
          label={option.label}
          selected={selected.includes(option.value)}
          onClick={() => onToggle(option.value)}
          labelSize="small"
          tooltipText={option.tooltipText}
        />
      ))}
    </styled.div>
  )
}
